import { fetchOk } from '@atlassian/mpac-fetch-wrapper';
import queryString from 'query-string';

/* Gets sales reports for a Partner */
export const getSalesReports = (mpacBaseUrl, partnerId, queryParams = {}) => {
  return fetchOk("".concat(mpacBaseUrl, "/rest/2/vendors/").concat(partnerId, "/reporting/sales/transactions/hosting?").concat(queryString.stringify(queryParams))).then(response => response.json());
};